import { REMOVER_FILTRO_PEDIDO } from '../types'

export default function removerFiltroPedido (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_PEDIDO
  }
}
